import {forwardRef, useState, useCallback} from 'react';

import styled from 'styled-components';

import {flipOnLTR} from '~/shared/theme/utils';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import FormPieInputBase from '~/shared/components/FormField/FormInput/FormPieInputBase';
import PieButton from '~/shared/theme/pie/PieButton';
import {getLocalizationService} from '~/shared/services/localisationService';

import eyeHideIconUrl from './assets/eyeHide.svg';
import eyeShowIconUrl from './assets/eyeShow.svg';
import {FormInputProps} from './types';

const StyledFormPieInputBase = styled(FormPieInputBase)`
  input {
    ${({theme}) => !theme.isLTR && `
      direction: ltr;
      text-align: right;
    `}
  }
`;

const ToggleButton = styled(PieButton)`
  padding: 8px;
  ${flipOnLTR`
    margin-left: -8px;
  `}
`;

const ToggleIcon = styled(ImageWithAlt)`
  width: 20px;
  height: 20px;
`;

export type FormPiePasswordInputProps = Omit<FormInputProps, 'type'>;

const FormPiePasswordInput = forwardRef<HTMLInputElement, FormPiePasswordInputProps>((props, ref) => {
  const {t} = getLocalizationService();
  const [showPassword, setShowPassword] = useState(false);
  const handleToggle = useCallback(() => {
    setShowPassword(prev => !prev);
  }, []);

  const htmlA11yLabel = t(showPassword ? 'hide_password' : 'show_password');

  return (
    <StyledFormPieInputBase
      {...props}
      type={showPassword ? 'text' : 'password'}
      ref={ref}
      sideComponent={
        <ToggleButton
          onClick={handleToggle}
          aria-label={htmlA11yLabel}
          variant="ghostLarge"
          iconButton
        >
          <ToggleIcon
            src={showPassword ? eyeHideIconUrl : eyeShowIconUrl}
            alt={htmlA11yLabel}
          />
        </ToggleButton>
      }
    />
  );
});

export default FormPiePasswordInput;
